<template>
  <div class="page" v-loading="loading">
    <el-form :model="form" :rules="rules" ref="form" label-width="90px">
      <el-form-item label-width="0">
        <h2>提现密码管理</h2>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="设置密码" prop="pass">
            <el-input v-model="form.pass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="确认密码" prop="checkPass">
            <el-input v-model="form.checkPass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  KSAXUpdatePassword,
} from "../../../api/api";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      form: {
        pass: "",
        checkPass: ""
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur', required: true, },
        ],
        checkPass: [
          { validator: validateCheckPass, trigger: 'blur', required: true, },
        ],
      }
    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true
          KSAXUpdatePassword({
            id: this.$route.query.id,
            password: this.form.checkPass,
            // path: "",
            // method: ""
          }).then(res => {
            if (res.data.result.success) {
              this.$router.go(-1)
              this.$message.success("修改成功")
            } else {
              this.$message.error(res.data.result.message)
            }
            setTimeout(() => {
              this.loading = false
            }, 500)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script>

<style scoped></style>
